import logo from './logo.svg';
import './App.css';
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route,useLocation,useNavigate } from 'react-router-dom';
import ToodhuLanding from './home';
import Synergy from './synergy';
import Operation from './operation';
import Synergyscreens from './synergyscreens';
import ContacForm from './contacForm';
import Pricing from './pricing';
import Customers from './customers';
import PrivacyPage from './privacyPage';
import TermsPage from './terms';
import BusinessCard, { SampleCampaign } from './campaign';
import BlogPage from './BlogPage';
import BlogDetails from './blogDetails';
import Medi from './medi';

// const GTM_ID = "GTM-56TG7H92"; 



const reverseMappings = {
  "/synergy360": "/business-networking-software",
  "/operation360": "business-workflow-automation-software",
  "/synergyscreen": "/synergy-screens",
  "/contactform": "/contact-us",
  "/pricing": "/pricing",
  "/customers": "/customers",
  "/privacy": "/privacy-policy",
  "/terms": "/terms-of-service",
};


const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (reverseMappings[location.pathname]) {
      setTimeout(() => {
        navigate(reverseMappings[location.pathname], { replace: true });
      }, 100); // Small delay to allow rendering
    }
  }, [location.pathname, navigate]);

  return null; // This component doesn't render anything
};




function App() {
  return (

    <>
    <Helmet>
    <script>
      {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TNRFDWB4');      
      `}
    </script>
  </Helmet>
    
    <Router>
      <RedirectHandler/>
    <Routes>
      <Route
        path="/"
        element={<ToodhuLanding/>}
      />
      <Route
        path="/business-networking-software"
        element={<Synergy/>}
      />
      <Route
        path="/business-workflow-automation-software"
        element={<Operation/>}
      />
      <Route
        path="/synergyscreen"
        element={<Synergyscreens/>}
      />

<Route
        path="/contact-us"
        element={<ContacForm/>}
      />


<Route
        path="/pricing"
        element={<Pricing/>}
      />

<Route
        path="/customers"
        element={<Customers/>}
      />

<Route
        path="/privacy-policy"
        element={<PrivacyPage/>}
      />

<Route
        path="/terms-of-service"
        element={<TermsPage/>}
      />


<Route
        path="/samplecampaign"
        element={<BusinessCard/>}
      />



   <Route path="/blogs/:slug" element={<BlogDetails />} />

        <Route path="/blogs/category/:categorySlug" element={<BlogPage />} />

        <Route path="/blogs/tags/:tagSlug" element={<BlogPage />} />

        <Route path="/blogs" element={<BlogPage />} />








    </Routes>




  </Router>
  </>

  );
}

export default App;
